@if (round) {
  @for (match of round.matches; track match.id) {
    <div class="nobreak">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="row">
          <div class="col-6">
            <h5>{{ tournament.name }}</h5>
          </div>
          <div class="col-6 text-end">
            {{ group.name }} {{ round.name }}
          </div>
        </div>
        <br>
        <br>
        <div class="row align-middle">
          <div class="col-6">
            <b>
              <app-team-display
                [team]="match.team1"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            </b>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <b>
              <app-team-display
                [team]="match.team2"
                [event]="this.event"
                [tournament]="this.tournament"
                [inline]="true">
              </app-team-display>
            </b>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline">
              <input matInput>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <u>Graag de winnaar omcirkelen</u>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    </div>
    <br>
  }
}
